import NavbarStyle from "../css/navbar.module.css";

const Navbar = () => {
  return (
    <div className={NavbarStyle.container}>
      <div className={NavbarStyle.abc}>
        <img
          className={NavbarStyle.fbImg}
          src="https://media.fenerbahce.org/FB/media/FB/Images/Logo/logo.png?ext=.png"
          alt=""
        />
        <h1 className={NavbarStyle.header}>Fenerbahçe Page</h1>
        <img
          className={NavbarStyle.fbImg}
          src="https://media.fenerbahce.org/FB/media/FB/Images/Logo/logo.png?ext=.png"
          alt=""
        />
      </div>
      <ul className={NavbarStyle.ul_list}>
        <li>
          <a href="#">Home</a>
        </li>
        <li>
          <a href="#">Athletes</a>
        </li>
        <li>
          <a href="#">Staff</a>
        </li>
        <li>
          <a href="#">Fixture</a>
        </li>
        <li>
          <a href="#">Contact</a>
        </li>
      </ul>
    </div>
  );
};

export default Navbar;
